import axios from "axios";
import { baseUrl } from '../../config/clientsConfig'

const LeadUploadService ={
    createBulkUpload: async(obj)=>{

return axios.post(`${baseUrl}/lead/create`,obj
// return axios.post(`${baseUrl}/leads/bulkUpload`,obj,

// {
//         headers: { "Content-Type": "multipart/form-data" },
//       }

)
    },
    createBulkUploadExcel : async (body)=>{
        return axios.post(`${baseUrl}/bulk-lead`,body)
    },
    validatePhoneNumber: (phoneNumber) =>
        axios.post(`${baseUrl}/leadphoneNumberValidator`, { phoneNumber }),
}

export default LeadUploadService;